import axios from 'axios'
import { ElMessage } from 'element-plus'

// 创建axios实例
const service = axios.create({
  baseURL: '/', // API的base_url
  timeout: 15000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 优化：为所有请求设置默认的短超时
    if (!config.timeout) {
      config.timeout = 8000; // 默认8秒超时，比之前更短
    }

    // 添加JWT token到请求头
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }

    // 开发环境下打印请求信息
    if (process.env.NODE_ENV === 'development') {
      console.log('公子羽', config.method?.toUpperCase(), config.url);
    }

    return config
  },
  error => {
    console.error('请求配置错误:', error);
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    // 处理401未授权错误（token过期或无效）
    if (error.response?.status === 401) {
      console.warn('认证失败，清除本地token');
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      // 可以在这里添加重定向到登录页的逻辑
      return Promise.resolve({ success: false, message: '认证失败，请登录账号' });
    }

    // 处理400错误（验证失败等）
    if (error.response?.status === 400) {
      const errorData = error.response.data;
      return Promise.resolve({
        success: false,
        message: errorData.message || '请求参数错误'
      });
    }

    // 优化：更好的错误处理，避免阻塞用户界面
    if (error.code === 'ECONNABORTED') {
      console.warn('请求超时，但不影响用户体验');
      return Promise.resolve({ success: false, message: '请求超时，请重试' });
    }

    if (error.response?.status >= 500) {
      console.warn('服务器错误，静默处理');
      return Promise.resolve({ success: false, message: '服务器错误，请稍后重试' });
    }

    // 其他错误
    return Promise.resolve({
      success: false,
      message: error.response?.data?.message || '请求失败，请重试'
    });
  }
)

export default service
